export const GET_ALL_TAGS = "GET_ALL_TAGS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_TAGS = "START_LOADING_TAGS";
export const STOP_LOADING_TAGS = "STOP_LOADING_TAGS";
export const ERROR_LOADING_TAGS = "ERROR_LOADING_TAGS";